import { Slider } from "@material-ui/core";
import { Button, Icon } from "@mui/material";
import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./Crop";
import "./Crop.css";

function CropComponents({ image, croppedImage, setCroppedImage }) {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const showCroppedImage = useCallback(async () => {
        try {
            const croppedImage = await getCroppedImg(
                image,
                croppedAreaPixels,
                rotation
            );
            setCroppedImage(croppedImage);
        } catch (e) {
            console.error(e);
        }
    }, [croppedAreaPixels, rotation, image]);

    const onClose = useCallback(() => {
        setCroppedImage(null);
    }, []);

    return (
        <>
            <div className="cropped-image-container">
                {croppedImage === null ? (
                    <Button
                        className="btn-crop"
                        variant="contained"
                        startIcon={<Icon>crop</Icon>}
                        // style={{
                        //     display: image === null || croppedImage !== null ? "none" : "block",
                        // }}
                        onClick={showCroppedImage}
                    >
                        Crop
                    </Button>
                ) : null}
                {croppedImage && (
                    <Button
                        startIcon={<Icon>restart_alt</Icon>}
                        variant="contained"
                        color="error"
                        onClick={onClose}
                    >
                        Reset
                    </Button>
                )}
            </div>
            <div
                className="main-container"
                style={{
                    display:
                        image === null || croppedImage !== null
                            ? "none"
                            : "block",
                }}
            >
                <div className="crop-container">
                    <Cropper
                        image={image}
                        crop={crop}
                        rotation={rotation}
                        zoom={zoom}
                        zoomSpeed={4}
                        maxZoom={3}
                        zoomWithScroll={true}
                        showGrid={true}
                        aspect={3 / 4}
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}
                        onRotationChange={setRotation}
                    />
                </div>
                <div className="d-flex justify-content-center">
                    <div className="controls">
                        <label className="lbl-crop">
                            Rotate
                            <Slider
                                value={rotation}
                                min={0}
                                max={360}
                                step={1}
                                aria-labelledby="rotate"
                                onChange={(e, rotation) =>
                                    setRotation(rotation)
                                }
                                className="range"
                            />
                        </label>
                        <label className="lbl-crop">
                            Zoom
                            <Slider
                                value={zoom}
                                min={1}
                                max={3}
                                step={0.1}
                                aria-labelledby="zoom"
                                onChange={(e, zoom) => setZoom(zoom)}
                                className="range"
                            />
                        </label>
                    </div>
                </div>
            </div>
            <div className="cropped-image-container">
                {croppedImage && (
                    <img
                        className="cropped-image"
                        src={croppedImage}
                        alt="cropped"
                    />
                )}
                {/* {croppedImage && <Button color='error' onClick={onClose}>Close</Button>} */}
            </div>
        </>
    );
}

export default CropComponents;
